// WARNING!
// This module is generated automatically.
// All the manual changes will be overwritten.

import { css } from 'styled-components';

export const swiperEffectCoverflowCSS = css``;
